import AnnotatorConstants from '../../annotator.constants';

export const cornerstoneRoiType = {
  caries: AnnotatorConstants.RECTANGLE_ROI,
  periapical_radiolucency: AnnotatorConstants.ELLIPTICAL_ROI,
  radiographic_boneloss: AnnotatorConstants.LENGTH,
  calculus: AnnotatorConstants.ELLIPTICAL_ROI,
  area_of_concern: AnnotatorConstants.RECTANGLE_ROI,
  restorative_adjacent_lucency: AnnotatorConstants.RECTANGLE_ROI,
};

export const TOOTH_DECAY_INFO_MESSAGE =
  'Calculated based on total size of all caries on tooth, relative to tooth crown size';
export const CARIES_DEPTH_INFO_MESSAGE =
  'AI-based estimate of caries depth/severity. Not shown for certain more incipient or borderline findings';
export const AREA_OF_CONCERN_SINGULAR = 'Area of concern';

const VIDEA_CARIES_ASSIST = 'Videa Caries Assist';
const VIDEA_PERIO_ASSIST = 'Videa Perio Assist';
const VIDEA_DENTAL_ASSIST = 'Videa Dental AI';
const VIDEA_ASSIST = 'Videa Assist';

export const ErrorMessageCodes = {
  VCA_FAILED: `${VIDEA_CARIES_ASSIST}: No caries results shown due to analysis failure`,
  VDA_FAILED: `${VIDEA_DENTAL_ASSIST}: No caries and restorative imperfections results shown due to analysis failure`,
  RBL_FAILED: `${VIDEA_PERIO_ASSIST}: No RBL results shown due to analysis failure`,
  PA_FAILED: `${VIDEA_DENTAL_ASSIST}: No caries results shown due to analysis failure`,
  PRL_FAILED: `${VIDEA_DENTAL_ASSIST}: No PRL results shown due to analysis failure`,
  CALCULUS_FAILED: `${VIDEA_DENTAL_ASSIST}: No calculus results shown due to analysis failure`,
  TDIS_FAILED: `${VIDEA_ASSIST}: Some AI results not shown due to analysis failure`,
  CARIES_ONLY: `${VIDEA_ASSIST}: All AI-detected caries boxes detected by AI are displayed, but some details (e.g., tooth decay) may not appear due to analysis failure`,
  MULTIPLE_FAILURES: `${VIDEA_ASSIST}: Some AI results not shown due to analysis failure`,
  FAILED: `${VIDEA_ASSIST}: No AI results shown due to analysis failure`,
} as const;
